import { Component } from '@angular/core';

@Component({
	selector: 'lib-card',
	imports: [],
	templateUrl: './card.component.html',
	styleUrl: './card.component.css',
})
export class CardComponent {}
